import { styled } from "@mui/material/styles";
import Media from "@bmi-digital/components/media";
import RichText from "../../RichText";

export const StyledEmbeddedRegistrationFormSection = styled("div")(
  ({ theme }) => ({
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "100%",
    "&>div": {
      width: "100%"
    },
    [theme.breakpoints.down(769)]: {
      flexDirection: "column-reverse"
    }
  })
);

export const FormContentWrapper = styled("div")(({ theme }) => ({
  padding: "60px 0",
  [theme.breakpoints.up(769)]: {
    padding: "60px 24px",
    width: "50%"
  }
}));

export const StyledMedia = styled(Media)(({ theme }) => ({
  height: "375px",
  [theme.breakpoints.up(376)]: {
    height: "414px"
  },
  [theme.breakpoints.up(769)]: {
    position: "absolute",
    top: 0,
    left: "50%",
    width: "50vw",
    height: "100%",
    maxHeight: "none"
  }
}));

export const StyledRichText = styled(RichText)({
  marginBottom: "24px"
});
